import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'
export { handleError }

// 統合基盤Token取得API
// 統合基盤からTokenを取得する。
export const fetchTokenExchange = (params = {}) => {
  const exchangeToken = params.integrated_system_exchange_token || ''
  const organizationId = params.organization_id

  const r = {
    ...params,
    integrated_system_exchange_token: exchangeToken,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/001', r)
    .catch(handleError)
}

// 統合基盤ログイン状況確認API
export const fetchVerify = (params = {}) => {
  const token = params.integrated_system_token || store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    integrated_system_token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/002', r)
    .catch(handleError)
}

// 統合基盤ユーザ詳細取得API
export const fetchUsersDetail = (params = {}) => {
  const token = params.integrated_system_token || store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    integrated_system_token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/003', r)
    .catch(handleError)
}

// 統合基盤更新チェックAPI
export const fetchUsersUpdateCheck = (params = {}) => {
  const token = params.integrated_system_token || store.state.auth.token
  const updatedAfter = params.updated_after
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    integrated_system_token: token,
    updated_after: updatedAfter,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/004', r)
    .catch(handleError)
}

// 統合基盤ログアウトAPI
export const logout = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    integrated_system_token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/005', r).catch(handleError)
}

// 統合基盤組織詳細API
export const fetchOrganizationDetail = (params = {}) => {
  const token = params.integrated_system_token || store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    integrated_system_token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/006', r)
    .catch(handleError)
}

// 統合基盤組織詳細API
export const postZendeskTicket = (params = {}) => {
  const r = {
    ...params
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/EX/007', r)
    .then(response => {
      return response
    })
    .catch(handleError)
}
